Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

require("core-js/fn/array/from");

require("core-js/fn/array/includes");

require("core-js/fn/map");

require("core-js/fn/object/get-own-property-symbols");

require("core-js/fn/object/is");

require("core-js/fn/object/keys");

require("core-js/fn/set");

var _Helmet = require("./Helmet");

var _Helmet2 = _interopRequireDefault(_Helmet);

exports["default"] = _Helmet2["default"];
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/lib/index.js
 ** module id = 25
 ** module chunks = 0
 **/